// src/extenders/countdown.js
function makeTimer() {
  const countdownContainers = document.querySelectorAll(".countdown-container");
  countdownContainers.forEach((countdownContainer) => {
    const timer = countdownContainer.querySelector('[id^="timer"]');
    if (!timer)
      return;
    const timerEndDate = timer.getAttribute("data-end-date");
    const timerEndTime = timer.getAttribute("data-end-time");
    const hideOnComplete = timer.getAttribute("data-hide-on-complete") === "true";
    const endMessage = timer.getAttribute("data-end-message");
    let endTimeString = timerEndDate && timerEndTime ? `${timerEndDate}T${timerEndTime}:00` : "2025-09-04T19:30:00";
    let endTime = new Date(endTimeString);
    endTime = Date.parse(endTime) / 1e3;
    let now = /* @__PURE__ */ new Date();
    now = Date.parse(now) / 1e3;
    let timeLeft = endTime - now;
    let days = Math.floor(timeLeft / 86400);
    let hours = Math.floor((timeLeft - days * 86400) / 3600);
    let minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
    let seconds = Math.floor(timeLeft - days * 86400 - hours * 3600 - minutes * 60);
    if (hours < "10") {
      hours = "0" + hours;
    }
    if (minutes < "10") {
      minutes = "0" + minutes;
    }
    if (seconds < "10") {
      seconds = "0" + seconds;
    }
    if (timeLeft <= 0) {
      if (hideOnComplete) {
        countdownContainer.style.display = "none";
      } else {
        timer.innerHTML = `<div class="end-message">${endMessage || "The countdown has ended!"}</div>`;
      }
      return;
    }
    const daysElement = timer.querySelector("#days");
    const hoursElement = timer.querySelector("#hours");
    const minutesElement = timer.querySelector("#minutes");
    const secondsElement = timer.querySelector("#seconds");
    const daysTimeElement = timer.querySelector("#days-time");
    const hoursTimeElement = timer.querySelector("#hours-time");
    const minutesTimeElement = timer.querySelector("#minutes-time");
    const secondsTimeElement = timer.querySelector("#seconds-time");
    if (daysElement) {
      if (days < 1) {
        daysElement.style.display = "none";
      } else {
        daysElement.style.display = "flex";
        if (daysTimeElement) {
          daysTimeElement.textContent = days;
        } else {
          daysElement.innerHTML = days + "&nbsp;<span>Days</span>&nbsp;";
        }
      }
    }
    if (hoursElement) {
      if (hoursTimeElement) {
        hoursTimeElement.textContent = hours;
      } else {
        hoursElement.innerHTML = hours + "&nbsp;<span>Hours</span>&nbsp;";
      }
    }
    if (minutesElement) {
      if (minutesTimeElement) {
        minutesTimeElement.textContent = minutes;
      } else {
        minutesElement.innerHTML = minutes + "&nbsp;<span>Minutes</span>&nbsp;";
      }
    }
    if (secondsElement) {
      if (secondsTimeElement) {
        secondsTimeElement.textContent = seconds;
      } else {
        secondsElement.innerHTML = seconds + "&nbsp;<span>Seconds</span>&nbsp;";
      }
    }
  });
}
setInterval(function() {
  makeTimer();
}, 1e3);
